import { render, staticRenderFns } from "./SideSaleButtons.vue?vue&type=template&id=0e0d848c&"
import script from "./SideSaleButtons.vue?vue&type=script&lang=ts&"
export * from "./SideSaleButtons.vue?vue&type=script&lang=ts&"
import style0 from "./SideSaleButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports